export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["राशि"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["परिणाम"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लेन-देन"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थिति अपडेट करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उपयोगी लिंक"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ब्लॉकचेन:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रगति में"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफलता"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["असफल"])}
}